<template>
	<!--外层box-->
	<div ref="diagram" class="diagram" @mouseenter="mouseEnter" @mouseout="mouseOut">
		<div class="move-box" :style="moveBoxStyle">
			<iframe ref="iframe" :style="frameStyle" class="small"
			        :src="src"
			        frameborder="0"></iframe>
		</div>
		<!--遮罩层 防止鼠标在iframe 中，无法触发滚轮事件-->
		<div class="mask" @mousemove="mouseMove" @mousedown="mouseDown" @mouseup="mouseUp"></div>

		<div class="btn row-center" v-if="!isFull" @click="full">
			<img src="../assets/img/fullScreen.png" alt="全屏">
			<span>全屏</span>
		</div>
		<div class="btn row-center" v-else @click="cancelFull">
			<img src="../assets/img/full_cancel.png" alt="取消全屏">
			<span>取消全屏</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Diagram",
		props: {
			src: String,
            isFull: Boolean
		},
		data() {
			return {
				// 全屏？
				// isFull: false,
				// 鼠标是否进入
				mouseInner: false,
				// 是否按住
				touched: false,

				// // 接线图地址
				// src: "http://47.99.177.252:5505/html/kaijun/peidian.html",

				// 外层宽高
				diagramWidth: 0,
				diagramHeight: 0,

				// 内层宽高
				iframeWidth: 0,
				iframeHeight: 0,

				w: 100,
				h: 100,
				max: 500,
				min: 100,

				// 鼠标当前位置
				x: 0,
				y: 0,

				// 拖动开始结束坐标
				startX: 0,
				startY: 0,
				endX: 0,
				endY: 0,


				// 定位值
				left: 0,
				top: 0,

				// 偏移量
				frameOffsetX: 0,
				frameOffsetY: 0,

				// 缩放率
				step: 0.02,

				// 移动位置
				moveX: 0,
				moveY: 0,
				// 拖动变化量
				varX: 0,
				varY: 0,
			}
		},
		mounted() {
			this.windowAddMouseWheel();
		},
		updated() {
			// 外层宽高
			let diagram = this.$refs.diagram
			this.diagramWidth = diagram.clientWidth
			this.diagramHeight = diagram.clientHeight

			// iframe 宽高
			let iframe = this.$refs.iframe
			this.iframeWidth = iframe.clientWidth
			this.iframeHeight = iframe.clientHeight
		},
		computed: {
			frameStyle() {
				// return `
				//     width:${this.w}%;
				//     height:${this.h}%;
				//     position: absolute;
				//     left: ${this.left}px;
				//     top: ${this.top}px;
				//     transform: translate(-${this.frameOffsetX}px, -${this.frameOffsetY}px);
				// `
				return `
                    width:${this.w}%;
                    height:${this.h}%;

                `
			},
			moveBoxStyle() {
				if (this.isFull) {
					return `
                        left:${this.moveX + this.varX}px;
                        top:${this.moveY + this.varY}px;
                    `
				}

				return `
                    left:50%;
                    top:50%;
                    transform:translate(-50%, -50%);
                `
			},
		},
		methods: {
			reset() {
				this.w = 100
				this.h = 100
				// 鼠标当前位置
				this.x = 0
				this.y = 0

				// 拖动开始结束坐标
				this.startX = 0
				this.startY = 0
				this.endX = 0
				this.endY = 0


				// 定位值
				this.left = 0
				this.top = 0

				// 偏移量
				this.frameOffsetX = 0
				this.frameOffsetY = 0

				// 移动位置
				this.moveX = 0
				this.moveY = 0
				// 拖动变化量
				this.varX = 0
				this.varY = 0
			},
			full() {
				this.isFull = true

				this.$emit("onFull")


			},
			cancelFull() {
				this.isFull = false

				this.$emit("onCancelFull")

                this.reset()
			},
			framePosition() {
				// 计算iframe 的定位
				this.left = this.x
				this.top = this.y

				// 偏移量
				this.frameOffsetX = this.x / this.diagramWidth * this.iframeWidth
				this.frameOffsetY = this.y / this.diagramHeight * this.iframeHeight
				// console.log(this.left, this.top)
			},
			add() {

				if (this.mouseInner && this.w < this.max) {
					this.w *= (1 + this.step)
					this.h *= (1 + this.step)

					if (this.w > this.max) {
						this.w = this.max
						this.h = this.max
					}

					// this.framePosition()
				}
			},
			subtract() {
				if (this.mouseInner && this.w > this.min) {
					this.w *= (1 - this.step)
					this.h *= (1 - this.step)

					if (this.w < this.min) {
						this.w = this.min
						this.h = this.min
					}
					// this.framePosition()
				}
			},
			mouseUp(e) {
				this.touched = false

				// 记录结束位置
				this.endX = e.offsetX
				this.endY = e.offsetY

				// 累加变化量
				this.moveX += this.varX
				this.moveY += this.varY

				// 清除变化量
				this.varX = 0
				this.varY = 0
			},
			mouseDown(e) {
				this.touched = true

				// 记录开始位置
				this.startX = e.offsetX
				this.startY = e.offsetY


			},
			mouseMove(e) {
				// console.log(e)
				this.mouseEnter(null)
				this.x = e.offsetX
				this.y = e.offsetY

				if (this.touched) {
					// 变化量
					this.varX = e.offsetX - this.startX
					this.varY = e.offsetY - this.startY

				}
			},

			windowAddMouseWheel() {
				var scrollFunc = e => {
					e = e || window.event;
					if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
						if (e.wheelDelta > 0) { //当滑轮向上滚动时
							this.up(e)
						}
						if (e.wheelDelta < 0) { //当滑轮向下滚动时
							this.down(e)
						}
					} else if (e.detail) {  //Firefox滑轮事件
						if (e.detail > 0) { //当滑轮向上滚动时
							this.up(e)
						}
						if (e.detail < 0) { //当滑轮向下滚动时
							this.down(e)
						}
					}
				};
				//给页面绑定滑轮滚动事件
				if (document.addEventListener) {
					document.addEventListener('DOMMouseScroll', scrollFunc, false);
				}
				//滚动滑轮触发scrollFunc方法
				window.onmousewheel = document.onmousewheel = scrollFunc;
			},
			mouseEnter(e) {
				// console.log("enter", e)
				this.mouseInner = true
			},
			mouseOut(e) {
				// console.log("out", e)
				this.mouseInner = false
			},
			down(e) {
				this.subtract()
			},
			up(e) {
				this.add()
			},
		}
	}
</script>

<style scoped lang="less">

    .full {

        .btn {
            top: 0 !important;
            bottom: -83vh !important;
            right: 2vw !important;
        }
    }


	.diagram {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
		background-color: rgba(0, 0, 0, 0);


		.move-box {
			width: 100%;
			height: 100%;
			position: relative;
			background-color: #000000;
		}

		.small, .mask {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			/*transition: all 0.1s;*/
		}

		.mask {
			z-index: 99;
			width: 100%;
			height: 100%;
		}

		.btn {
			.wh(0, -36);
			position: absolute;
			top: @h;
			right: @w;
			z-index: 99999;
			color: #ffffff;
			font-size: 18px;
			cursor: pointer;

			img {
				.wh(16, 16);
				width: @w;
				height: @h;
				margin-right: 7 / 1920 * 100vw;
			}
		}
	}
</style>